<template>
  <div class="date-time-input">
    <input type="text"
           ref="input"
           class="form-control"
           autocomplete="off"
           placeholder="TT.MM.JJJJ HH:MM">
  </div>
</template>

<script>
// Same value format as a native datetime-local input.
const MODEL_FORMAT = 'YYYY-MM-DDTHH:mm';

export default {
  name: 'DateTimeInput',
  props: {
    value: {type: String, default: ''},
  },
  mounted() {
    $(this.$refs.input).datetimepicker({
      locale: 'de',
      format: 'DD.MM.YYYY HH:mm',
      defaultDate: this.value ? moment(this.value, MODEL_FORMAT) : false,
      useCurrent: false,
      showTodayButton: true,
      showClear: true,
      toolbarPlacement: 'bottom',
      sideBySide: true,
      icons: {
        time: 'fa fa-clock-o',
        date: 'fa fa-calendar-o',
        up: 'fa fa-arrow-up',
        down: 'fa fa-arrow-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
      },
    }).on('dp.change', event => this.$emit('input', event.date ? event.date.format(MODEL_FORMAT) : ''));
  },
  beforeDestroy() {
    $(this.$refs.input).data('DateTimePicker').destroy();
  },
}
</script>

<style scoped>
.date-time-input {
  position: relative;
}
</style>
